import { Badge } from '@civilgrid/ui/components';
import type { ColumnDef } from '@tanstack/react-table';
import { DateTime } from 'luxon';
import type { MergeHistoryEntry } from '~/api/civilsearch';

export function formatDate(iso: string | null) {
  if (!iso) return '—';
  const dt = DateTime.fromISO(iso);
  return dt.isValid ? dt.toFormat('MM/dd/yyyy HH:mm') : iso;
}

function formatDirection(direction: MergeHistoryEntry['direction']) {
  return direction === 'inbound' ? 'Inbound' : 'Outbound';
}

export const columns: ColumnDef<MergeHistoryEntry>[] = [
  {
    id: 'agency',
    header: 'Agency',
    accessorFn: (d) => d.agencyName ?? '(deleted)',
  },
  {
    id: 'direction',
    header: 'Direction',
    size: 110,
    accessorFn: (d) => formatDirection(d.direction),
    cell: ({ row }) => {
      const direction = row.original.direction;
      const label = formatDirection(direction);
      return (
        <Badge
          color={direction === 'inbound' ? 'green' : 'yellow'}
          data-testid={`agency-history-row-direction-${row.id}`}
        >
          {label}
        </Badge>
      );
    },
  },
  {
    id: 'mergedAt',
    header: 'Merged At',
    size: 175,
    // ISO strings sort chronologically; the cell shows the formatted date.
    accessorFn: (d) => d.mergedAt ?? '',
    cell: ({ row }) => formatDate(row.original.mergedAt),
  },
  {
    id: 'mergedBy',
    header: 'Performed By',
    accessorFn: (d) => d.mergedBy?.name || d.mergedBy?.email || '(unknown)',
  },
];
